import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { append, patch, removeItem } from '@ngxs/store/operators';
import { ToastActions } from './toast.actions';
import { Toast, ToastStateModel } from './toast.models';

@State<ToastStateModel>({
  name: 'toasts',
  defaults: {
    toasts: [],
  },
})
@Injectable()
export class ToastState {
  @Selector()
  static toasts(state: ToastStateModel): Toast[] {
    return state.toasts;
  }

  @Action(ToastActions.ShowSuccess)
  showSuccess(ctx: StateContext<ToastStateModel>, action: ToastActions.ShowSuccess): void {
    const toast = {
      type: 'success',
      header: action.header,
      classname: 'bg-dark border-1 border-light text-light',
      text: action.text,
      delay: 5000,
      autohide: true,
    } as Toast;

    ctx.setState(
      patch({
        toasts: append([toast]),
      })
    );
  }

  @Action(ToastActions.ShowInformation)
  showInformation(ctx: StateContext<ToastStateModel>, action: ToastActions.ShowInformation): void {
    const toast = {
      type: 'information',
      header: action.header,
      classname: 'bg-light border-1 border-dark text-info',
      text: action.text,
      delay: 5000,
      autohide: true,
    } as Toast;

    ctx.setState(
      patch({
        toasts: append([toast]),
      })
    );
  }

  @Action(ToastActions.ShowWarning)
  showWarning(ctx: StateContext<ToastStateModel>, action: ToastActions.ShowWarning): void {
    const toast = {
      type: 'warning',
      classname: 'bg-warning border-1 border-light text-light',
      text: action.text,
      delay: 5000,
      autohide: true,
    } as Toast;

    ctx.setState(
      patch({
        toasts: append([toast]),
      })
    );
  }

  @Action(ToastActions.ShowUserEvent)
  showUserEvent(ctx: StateContext<ToastStateModel>, action: ToastActions.ShowUserEvent): void {
    const toast = {
      type: 'user',
      header: action.header,
      classname: 'bg-info border-1 border-dark text-dark',
      text: action.text,
      delay: 5000,
      autohide: true,
    } as Toast;

    ctx.setState(
      patch({
        toasts: append([toast]),
      })
    );
  }

  @Action(ToastActions.ShowError)
  showError(ctx: StateContext<ToastStateModel>, action: ToastActions.ShowError): void {
    const toast = {
      type: 'error',
      classname: 'bg-danger border-1 border-light text-light',
      text: action.text,
      delay: 5000,
      autohide: true,
    } as Toast;

    ctx.setState(
      patch({
        toasts: append([toast]),
      })
    );
  }

  @Action(ToastActions.Remove)
  remove(ctx: StateContext<ToastStateModel>, action: ToastActions.Remove): void {
    ctx.setState(
      patch({
        toasts: removeItem<Toast>(toast => toast === action.toast),
      })
    );
  }
}
